export { SkyPagingComponent } from './paging.component';
export { SkyPagingModule } from './paging.module';
